import LazyDisp from './lazydisp';
import Header from './header';
import ScrollHint from 'scroll-hint';
// import FirstViewEndObserver from "../extended_class/FirstViewEndObserver";

const [d] = [document];

export default class COMMON {
  constructor(opt) {
    // settings
    this.opt = Object.assign({
      lazydisp: '[data-lazydisp]',
    }, opt);
	}
  init()
  {
    this.Header = new Header();
    this.ScrollHint = new ScrollHint('.js-scrollable', {
      // suggestiveShadow: true,//影をつける
      i18n: {
        scrollable: '横スクロール可能です',
      },
    });
    this.initCustomScrollbars();
    this.initHashPositionAdjustment();

    // イベント一覧
    d.addEventListener('Lazydisp.beforeInit', () => false);

		// イベント発火
    d.dispatchEvent(new CustomEvent('common.beforeInit', { detail: this }));
    this.LazyDisp = new LazyDisp(this.opt.lazydisp);
    // console.log(this.LazyDisp);
  }

  initHashPositionAdjustment() {
    const adjustHashPosition = () => {
      if (!window.location.hash) return;

      let target;
      try {
        target = d.getElementById(
          decodeURIComponent(window.location.hash.slice(1))
        );
      } catch (error) {
        return;
      }

      if (!target) return;

      d.querySelectorAll('.is-scroll-target').forEach((element) => {
        element.classList.remove('is-scroll-target');
      });
      target.classList.add('is-scroll-target');

      const scrollToTarget = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const prefersReducedMotion = window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches;
            const html = d.documentElement;
            const scrollBehavior = html.style.scrollBehavior;
            const startPosition = window.pageYOffset;
            const getTargetPosition = () => {
              const scrollMarginTop = parseFloat(
                window.getComputedStyle(target).scrollMarginTop
              ) || 0;

              return Math.max(
                0,
                target.getBoundingClientRect().top
                  + window.pageYOffset
                  - scrollMarginTop
              );
            };

            html.style.scrollBehavior = 'auto';

            if (prefersReducedMotion) {
              window.scrollTo(0, getTargetPosition());
              html.style.scrollBehavior = scrollBehavior;
              target.classList.remove('is-scroll-target');
              return;
            }

            const distance = Math.abs(getTargetPosition() - startPosition);
            const duration = Math.min(1000, Math.max(500, distance * 0.2));
            let startTime;

            const animateScroll = (currentTime) => {
              if (!startTime) startTime = currentTime;

              const progress = Math.min((currentTime - startTime) / duration, 1);
              const easedProgress = 1 - Math.pow(1 - progress, 3);
              const targetPosition = getTargetPosition();

              window.scrollTo(
                0,
                startPosition
                  + (targetPosition - startPosition) * easedProgress
              );

              if (progress < 1) {
                requestAnimationFrame(animateScroll);
                return;
              }

              window.scrollTo(0, getTargetPosition());
              html.style.scrollBehavior = scrollBehavior;
              target.classList.remove('is-scroll-target');
            };

            requestAnimationFrame(animateScroll);
          });
        });
      };

      if (d.fonts && d.fonts.ready) {
        d.fonts.ready.then(scrollToTarget);
      } else {
        scrollToTarget();
      }
    };

    window.addEventListener('load', adjustHashPosition);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) adjustHashPosition();
    });

    d.addEventListener('click', (event) => {
      if (
        event.defaultPrevented
        || event.button !== 0
        || event.metaKey
        || event.ctrlKey
        || event.shiftKey
        || event.altKey
      ) return;

      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank') return;

      const url = new URL(link.href, window.location.href);
      const isSamePage = url.origin === window.location.origin
        && url.pathname === window.location.pathname
        && url.search === window.location.search;

      if (!isSamePage || !url.hash) return;

      let target;
      try {
        target = d.getElementById(decodeURIComponent(url.hash.slice(1)));
      } catch (error) {
        return;
      }

      if (!target) return;

      event.preventDefault();

      if (window.location.hash !== url.hash) {
        window.history.pushState(null, '', url.hash);
      }

      adjustHashPosition();
    });

    window.addEventListener('popstate', () => {
      if (window.location.hash) adjustHashPosition();
    });
  }

  initCustomScrollbars() {
    d.querySelectorAll('[data-custom-scroll]').forEach((scrollElement) => {
      const scrollbar = scrollElement.nextElementSibling;
      const track = scrollbar
        ? scrollbar.querySelector('[data-custom-scrollbar-track]')
        : null;
      const thumb = scrollbar
        ? scrollbar.querySelector('[data-custom-scrollbar-thumb]')
        : null;

      if (!scrollbar || !scrollbar.matches('[data-custom-scrollbar]') || !track || !thumb) return;

      const updateThumb = () => {
        const maxScroll = scrollElement.scrollWidth - scrollElement.clientWidth;
        const thumbWidth = Math.min(
          track.clientWidth,
          Math.max(
            40,
            track.clientWidth * (scrollElement.clientWidth / scrollElement.scrollWidth)
          )
        );
        const maxThumbMove = track.clientWidth - thumbWidth;
        const thumbPosition = maxScroll > 0
          ? (scrollElement.scrollLeft / maxScroll) * maxThumbMove
          : 0;

        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${thumbPosition}px)`;
      };

      let dragStartX = 0;
      let scrollStart = 0;
      let contentDragStartX = 0;
      let contentScrollStart = 0;

      thumb.addEventListener('pointerdown', (event) => {
        dragStartX = event.clientX;
        scrollStart = scrollElement.scrollLeft;
        thumb.setPointerCapture(event.pointerId);
        thumb.classList.add('is-dragging');
      });

      thumb.addEventListener('pointermove', (event) => {
        if (!thumb.hasPointerCapture(event.pointerId)) return;

        const maxThumbMove = track.clientWidth - thumb.offsetWidth;
        const maxScroll = scrollElement.scrollWidth - scrollElement.clientWidth;
        if (maxThumbMove <= 0) return;

        scrollElement.scrollLeft = scrollStart
          + ((event.clientX - dragStartX) / maxThumbMove) * maxScroll;
      });

      const stopDragging = (event) => {
        if (thumb.hasPointerCapture(event.pointerId)) {
          thumb.releasePointerCapture(event.pointerId);
        }
        thumb.classList.remove('is-dragging');
      };

      thumb.addEventListener('pointerup', stopDragging);
      thumb.addEventListener('pointercancel', stopDragging);

      scrollElement.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        event.preventDefault();
        contentDragStartX = event.clientX;
        contentScrollStart = scrollElement.scrollLeft;
        scrollElement.setPointerCapture(event.pointerId);
        scrollElement.classList.add('is-dragging');
      });

      scrollElement.addEventListener('pointermove', (event) => {
        if (!scrollElement.hasPointerCapture(event.pointerId)) return;

        scrollElement.scrollLeft = contentScrollStart
          - (event.clientX - contentDragStartX);
      });

      const stopContentDragging = (event) => {
        if (scrollElement.hasPointerCapture(event.pointerId)) {
          scrollElement.releasePointerCapture(event.pointerId);
        }
        scrollElement.classList.remove('is-dragging');
      };

      scrollElement.addEventListener('pointerup', stopContentDragging);
      scrollElement.addEventListener('pointercancel', stopContentDragging);
      scrollElement.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });
      scrollElement.addEventListener('scroll', updateThumb, { passive: true });
      window.addEventListener('resize', updateThumb, { passive: true });
      updateThumb();
    });
  }

  domReady() {
    // console.log(`test`);
  }
}
